module.exports = __webpack_public_path__ + "40007f6542051f390df6290c9c31c1d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/boston_common.png
// module id = 1812
// module chunks = 0